import axios from "axios";
import config from "../configs";
import { encrypt } from "./crypto";

const api = {
  get: (path, hideLoader) =>
    new Promise(async (resolve, reject) => {
      try {
        const loader = document.querySelector(".loader");

        if (!hideLoader) loader.style.display = "flex";

        const { data } = await axios.get(`${config.apiBaseURL}${path}`, {
          headers: {
            "x-api-token": encrypt(new Date().toString()),
          },
        });

        loader.style.display = "none";

        if (data?.status == "FAILURE") return reject(data?.msg);

        resolve(data?.data);
      } catch (err) {
        reject(err);
      }
    }),
};

export default api;
